import { LiteralObject } from 'viggo-sistemas-core-web';
import {
  CONFIG_PASSOS,
  getInfoStep
} from './constants/constant_primeiros_passos';
import { SettingsPrimeirosPassosComercial } from './primeiros_passos_comercial';
import { SettingsPrimeirosPassosFinanceiro } from './primeiros_passos_financeiro';
import { SettingsPrimeirosPassosFical } from './primeiros_passos_fiscal';
import { SettingsPrimeirosPassosProducao } from './primeiros_passos_producao';

export interface IPrimeirosPassos {
  posicao: number;
  passo_valor: string;
  titulo: string;
  descricao: string;
  concluido: boolean;
  color: string;
  icon: string;
  image: string;
  toolTip: string;
  link: ISubPasso[];
}

export interface ISubPasso {
  titulo: string;
  passo: string;
  concluido: boolean;
  url: string;
}

export const ordemPosicao = (a: IPrimeirosPassos, b: IPrimeirosPassos) =>
  a.posicao > b.posicao && a.posicao !== null && b.posicao !== null ? 1 : -1;

/**
 * MODULOS:
 * - PRODUÇÃO E CONTROLE DE ESTOQUE
 * - COMERCIAL
 * - FINANCEIRO
 * - FISCAL
 */
export class SettingsPrimeirosPassos {
  passos = [
    {
      posicao: 0,
      passo_valor: 'INFO_EMPRESA',
      concluido: false,
      link: [
        {
          passo: 'CADASTRO_EMPRESA',
          concluido: false
        }
      ]
    },
    {
      posicao: 1,
      passo_valor: 'INFO_EMPRESA_REGRAS',
      concluido: false,
      link: [
        {
          passo: 'EMPRESA_REGRAS',
          concluido: false
        }
      ]
    },
    {
      posicao: 2,
      passo_valor: 'INFO_PARCEIROS',
      concluido: false,
      link: [
        {
          concluido: false,
          passo: 'CADASTRO_CLIENTE'
        },
        {
          concluido: false,
          passo: 'CADASTRO_VENDEDOR'
        },
        {
          concluido: false,
          passo: 'CADASTRO_FUNCIONARIO'
        },
        {
          concluido: false,
          passo: 'CADASTRO_FORNECEDOR'
        },
        {
          concluido: false,
          passo: 'CADASTRO_FABRICANTE'
        }
      ]
    }
  ] as IPrimeirosPassos[];

  ultimo_passo = 'UNKNONW';

  pulou_passo = false;

  plano = 'PRODUCAO';

  constructor(
    public domain_settings: LiteralObject,
    public application_settings = {},
    public planoSelecionado = 'PRODUCAO'
  ) {
    const domain_config_inicial = domain_settings['config_inicial'] ?? {};
    this.ultimo_passo = domain_config_inicial['ultimo_passo'] ?? 'UNKNOWN';
    this.pulou_passo = domain_config_inicial['pulou_passo'] ?? false;
    this.plano = planoSelecionado;
    //PASSOS
    if (domain_config_inicial['passos']) {
      this.passos = domain_config_inicial['passos'];
      this.buildConfigInicial();
    } else {
      this.buildConfigInicial();
    }
  }

  buildConfigInicial() {
    var config_inicial_bck = {
      passos: this.passos,
      ultimo_passo: this.ultimo_passo
    };
    if (this.plano === 'PRODUCAO') {
      config_inicial_bck = new SettingsPrimeirosPassosProducao(
        config_inicial_bck
      ).getSettingsPassosProducao(config_inicial_bck);
    }
    if (this.plano === 'COMERCIAL') {
      config_inicial_bck = new SettingsPrimeirosPassosComercial(
        config_inicial_bck
      ).getSettingsPassosComercial(config_inicial_bck);
    }
    if (this.plano === 'FINANCEIRO') {
      config_inicial_bck = new SettingsPrimeirosPassosFinanceiro(
        config_inicial_bck
      ).getSettingsPassosFinanceiro(config_inicial_bck);
    }
    if (this.plano === 'FISCAL') {
      config_inicial_bck = new SettingsPrimeirosPassosFical(
        config_inicial_bck
      ).getSettingsPassosFiscal(config_inicial_bck);
    }
    this.passos = config_inicial_bck.passos;
    this.ultimo_passo = config_inicial_bck.ultimo_passo;
  }

  getConfigInicialSettings(domain_settings) {
    return {
      passos: getInfoStep(this.passos, CONFIG_PASSOS),
      ultimo_passo: this.ultimo_passo,
      pulou_passo: this.pulou_passo,
    };
  }
}
